/* Neue Suche (Okt. 2026) – Such-Fenster aus snippets/sd-suche.liquid
   · öffnet über jede Schaltfläche mit [data-sds-open] (Lupe im Header, Suchfeld im mobilen Menü)
   · Ergebnisse live aus der Shopify-Schnellsuche (/search/suggest.json)
   · Trefferzahl für "Alle … Ergebnisse" aus templates/search.sd-anzahl.liquid
   · Rabatt-Aktion: "−25 %" an Produkten der Aktion (window.RABATT_AKTION aus snippets/aktion-head.liquid) */
(function () {
  'use strict';

  var root = document.querySelector('[data-sds]');
  if (!root) return;
  document.body.appendChild(root); /* nicht im klebenden Header-Abschnitt lassen (position: fixed) */

  var MOBIL = window.matchMedia('(max-width: 989px)');
  var input = root.querySelector('[data-sds-input]');
  var form = root.querySelector('[data-sds-form]');
  var leeren = root.querySelector('[data-sds-leeren]');
  var vLeer = root.querySelector('[data-sds-leer]');
  var vTreffer = root.querySelector('[data-sds-treffer]');
  var vKeine = root.querySelector('[data-sds-keine]');
  var fuss = root.querySelector('[data-sds-fuss]');
  var alle = root.querySelector('[data-sds-alle]');
  var elProdukte = root.querySelector('[data-sds-produkte]');
  var elVorschlaege = root.querySelector('[data-sds-vorschlaege]');
  var elKategorien = root.querySelector('[data-sds-kategorien]');
  var elSeiten = root.querySelector('[data-sds-seiten]');
  var elWort = root.querySelector('[data-sds-wort]');
  var oeffner = Array.prototype.slice.call(document.querySelectorAll('[data-sds-open]'));
  var headerLupe = document.querySelector('.sdh [data-sds-open]');
  var letzterOeffner = null;

  var SUCHE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'search';
  var EUR = (window.Intl && Intl.NumberFormat) ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }) : null;
  var timer = null, laufend = null, anfrageNr = 0;
  var hilfeTreffer = root.querySelector('[data-sds-hilfe-treffer]');
  var hilfeLeer = root.querySelector('[data-sds-hilfe-leer]');
  var hilfeTimer = null, leerTimer = null;
  var WARTE_TREFFER = 4000; /* so lange nach dem letzten Tippen, während die Ergebnisse angeschaut werden */
  var WARTE_LEER = 6000;    /* so lange nach dem Öffnen, falls noch nichts getippt wurde */

  /* "Nicht das Richtige dabei?" erst einblenden, wenn der Kunde eine Weile schaut – nicht sofort.
     Jeder neue Tastendruck startet die Wartezeit neu; einmal sichtbar, bleibt der Kasten bis zum Schließen. */
  function einblenden(el) { el.hidden = false; el.classList.add('sds-ein'); }
  function hilfeSpaeter() {
    if (!hilfeTreffer || !hilfeTreffer.hidden) return;
    clearTimeout(hilfeTimer);
    hilfeTimer = setTimeout(function () {
      if (!vTreffer.hidden && !root.hidden) einblenden(hilfeTreffer);
    }, WARTE_TREFFER);
  }
  function leerSpaeter() {
    if (!hilfeLeer || !hilfeLeer.hidden) return;
    clearTimeout(leerTimer);
    leerTimer = setTimeout(function () {
      if (!vLeer.hidden && !root.hidden) einblenden(hilfeLeer);
    }, WARTE_LEER);
  }
  function hilfeZurueck() {
    clearTimeout(hilfeTimer); clearTimeout(leerTimer);
    [hilfeTreffer, hilfeLeer].forEach(function (el) {
      if (el) { el.hidden = true; el.classList.remove('sds-ein'); }
    });
  }

  /* ---------- Hilfen ---------- */
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function preis(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return EUR ? EUR.format(n) : n.toFixed(2).replace('.', ',') + ' €';
  }
  function bild(url, breite) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }
  function bildUrl(o) {
    if (!o) return '';
    if (typeof o.image === 'string') return o.image;
    if (o.image && o.image.url) return o.image.url;
    if (o.featured_image && o.featured_image.url) return o.featured_image.url;
    return '';
  }
  function suchUrl(q) { return SUCHE + '?q=' + encodeURIComponent(q); }
  function aktionAn(handle) {
    var C = window.RABATT_AKTION;
    if (!C || !C.produkte || (C.ende && Date.now() > C.ende)) return '';
    return C.produkte.indexOf(handle) > -1 ? '−' + C.prozent + ' %' : '';
  }
  function hervorheben(text, q) {
    var t = String(text), i = t.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return esc(t);
    return esc(t.slice(0, i)) + '<b>' + esc(t.slice(i, i + q.length)) + '</b>' + esc(t.slice(i + q.length));
  }
  var PFEIL = '<svg class="sds__produkt-pfeil" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var LUPE = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="6"/><path d="M20 20l-4.5-4.5"/></svg>';

  /* ---------- Ansichten ---------- */
  function zeige(welche) {
    vLeer.hidden = welche !== 'leer';
    vTreffer.hidden = welche !== 'treffer' && welche !== 'lade';
    vKeine.hidden = welche !== 'keine';
    fuss.hidden = welche !== 'treffer';
  }
  function ladeAnsicht() {
    var html = '';
    for (var i = 0; i < 5; i++) {
      html += '<div class="sds__produkt sds__lade" aria-hidden="true"><span class="sds__produkt-bild"></span>' +
        '<span class="sds__produkt-text"><span class="sds__produkt-titel">&nbsp;</span><span class="sds__produkt-preis">&nbsp;</span></span></div>';
    }
    elProdukte.innerHTML = html;
    zeige('lade');
  }

  function block(name, html) {
    var b = root.querySelector('[data-sds-block="' + name + '"]');
    var ziel = { vorschlaege: elVorschlaege, kategorien: elKategorien, seiten: elSeiten }[name];
    ziel.innerHTML = html;
    b.hidden = !html;
  }

  function darstellen(q, r) {
    var produkte = (r.products || []).filter(function (p) {
      return p.type !== 'PPLR_HIDDEN_PRODUCT' && !(p.tags || []).some(function (t) { return t === 'legacy'; });
    }).slice(0, 5);
    var kategorien = (r.collections || []).slice(0, 3);
    var seiten = (r.pages || []).concat(r.articles || []).slice(0, 2);
    var vorschlaege = (r.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);

    if (!produkte.length && !kategorien.length && !seiten.length) {
      elWort.textContent = q;
      zeige('keine');
      return;
    }

    block('vorschlaege', vorschlaege.map(function (s) {
      return '<a class="sds__vorschlag" href="' + esc(suchUrl(s.text)) + '" data-sds-begriff="' + esc(s.text) + '">' + LUPE + '<span>' + hervorheben(s.text, q) + '</span></a>';
    }).join(''));

    block('kategorien', kategorien.map(function (c) {
      var b = bildUrl(c);
      return '<a class="sds__eintrag" href="' + esc(c.url) + '">' +
        (b ? '<img src="' + esc(bild(b, 120)) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="sds__eintrag-ph"></span>') +
        '<span class="sds__eintrag-text"><span class="sds__eintrag-titel">' + esc(c.title) + '</span><span class="sds__eintrag-sub">Kategorie ansehen</span></span></a>';
    }).join(''));

    block('seiten', seiten.map(function (s) {
      return '<a class="sds__eintrag" href="' + esc(s.url) + '"><span class="sds__eintrag-text"><span class="sds__eintrag-titel">' + esc(s.title) + '</span></span></a>';
    }).join(''));

    elProdukte.innerHTML = produkte.length ? produkte.map(function (p, i) {
      var min = parseFloat(p.price_min || p.price), max = parseFloat(p.price_max || p.price);
      var pct = aktionAn(p.handle);
      var b = bildUrl(p);
      return '<a class="sds__produkt" href="' + esc((p.url || '').split('?')[0]) + '" style="animation-delay:' + (i * 50) + 'ms">' +
        '<span class="sds__produkt-bild">' + (b ? '<img src="' + esc(bild(b, 360)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="sds__produkt-text"><span class="sds__produkt-titel">' + esc(p.title) + '</span>' +
        '<span class="sds__produkt-preis">' + (max > min ? 'ab ' : '') + esc(preis(min)) + (pct ? ' <i class="ra-chip-sds">' + pct + '</i>' : '') + '</span></span>' +
        PFEIL + '</a>';
    }).join('') : '<p class="sds__eintrag-sub">Keine Produkte – schaut in die passenden Kategorien links.</p>';

    alle.href = suchUrl(q);
    alle.textContent = 'Alle Ergebnisse für „' + q + '“ anzeigen';
    zeige('treffer');
    hilfeSpaeter();
    anzahlHolen(q);
  }

  function anzahlHolen(q) {
    var nr = anfrageNr;
    fetch(SUCHE + '?view=sd-anzahl&q=' + encodeURIComponent(q), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        if (nr !== anfrageNr) return;
        var n = JSON.parse(t).anzahl;
        if (n > 0) alle.textContent = MOBIL.matches
          ? 'Alle ' + n + ' Ergebnisse anzeigen'
          : 'Alle ' + n + ' Ergebnisse für „' + q + '“ anzeigen';
      })
      .catch(function () {});
  }

  function suchen() {
    var q = input.value.trim();
    leeren.hidden = !input.value;
    anfrageNr++;
    if (laufend && laufend.abort) laufend.abort();
    if (q.length < 2) { zeige('leer'); leerSpaeter(); return; }
    if (vTreffer.hidden) ladeAnsicht();
    var nr = anfrageNr;
    laufend = window.AbortController ? new AbortController() : null;
    var url = SUCHE + '/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query,page,article&resources[limit]=6' +
      '&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin', signal: laufend ? laufend.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (nr !== anfrageNr) return;
        darstellen(q, (d.resources && d.resources.results) || {});
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        /* Schnellsuche nicht erreichbar → einfach die normale Suchseite anbieten */
        alle.href = suchUrl(q);
        alle.textContent = 'Nach „' + q + '“ suchen';
        elProdukte.innerHTML = '';
        zeige('treffer');
      });
  }

  /* ---------- Öffnen / Schließen ---------- */
  function oben() {
    var h = document.querySelector('.sdh-section');
    var top = (!MOBIL.matches && h) ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
    root.style.setProperty('--sds-top', top + 'px');
  }
  function oeffnen(e) {
    letzterOeffner = e && e.currentTarget || headerLupe;
    var menue = document.querySelector('[data-sdh-sheet]:not([hidden]) .sdh-sheet__close');
    if (menue) menue.click();
    var hs = document.querySelector('.sdh-section');
    if (hs) hs.classList.remove('sdh-versteckt');
    oben();
    root.hidden = false;
    if (input.value.trim().length < 2) leerSpaeter();
    document.documentElement.classList.add('sds-offen');
    if (headerLupe) headerLupe.setAttribute('aria-expanded', 'true');
    input.focus();
    if (input.value) input.select();
  }
  function schliessen() {
    if (root.hidden) return;
    root.hidden = true;
    hilfeZurueck();
    document.documentElement.classList.remove('sds-offen');
    if (headerLupe) headerLupe.setAttribute('aria-expanded', 'false');
    if (letzterOeffner && document.contains(letzterOeffner) && letzterOeffner.offsetParent) letzterOeffner.focus({ preventScroll: true });
  }

  oeffner.forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (!root.hidden && b === headerLupe) { schliessen(); return; }
      oeffnen(e);
    });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-sds-close]'), function (b) {
    b.addEventListener('click', schliessen);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) { e.preventDefault(); schliessen(); }
    if (e.key === '/' && root.hidden && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '') && !(document.activeElement || {}).isContentEditable) {
      e.preventDefault(); oeffnen();
    }
  });
  window.addEventListener('resize', function () { if (!root.hidden) oben(); });

  input.addEventListener('input', function () {
    clearTimeout(hilfeTimer); clearTimeout(leerTimer); /* tippt noch → Kasten wartet */
    clearTimeout(timer);
    timer = setTimeout(suchen, 180);
  });
  leeren.addEventListener('click', function () {
    input.value = '';
    suchen();
    input.focus();
  });
  /* Beliebte Suchen / Vorschläge: direkt im Fenster weitersuchen statt Seite zu wechseln */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sds-begriff]');
    if (!a || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    input.value = a.getAttribute('data-sds-begriff');
    suchen();
    input.focus();
  });
  form.addEventListener('submit', function (e) {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); }
  });
})();
